<div class="container">
  <div class="absolute">
    @if (!selectedPhoto) {
      <div class="add">
        <span></span>
        <p translate>clgkrhoq7000008l88r5c6z7y</p>
      </div>
    }
  </div>
  @if (selectedPhoto) {
    <div class="photo">
      <lib-cover [imageSize]="imageSize" [point]="point" [url]="url"></lib-cover>
      <div class="edit">
        <lib-button #menuTrigger [matMenuTriggerFor]="menu" icon-only>
          <mat-icon>more_vert</mat-icon>
        </lib-button>
        <mat-menu #menu="matMenu" >
          <lib-button (clicked)="reset.emit(); selectedPhoto = null" mat-menu-element
            [showConfirmDialog]="true"
            confirm
            forceContext="publicSessionEditor"
            explainerMessage="{{'clgkrnlqh000008k7hgvw0tv9' | translate : 'publicSessionEditor'|async}}"
            translate>
            remove
          </lib-button>
          <lib-button (click)="edit()" mat-menu-element
            forceContext="publicSessionEditor"
          translate>edit</lib-button>
        </mat-menu>
      </div>
    </div>
  }
  @if (!selectedPhoto && !contextId) {
    <input
      #me
      (change)="uploadFromDisk(me)"
      type="file"
      />
  }
  @if (isUploading$ | async) {
    <mat-progress-bar
      mode="query"
    ></mat-progress-bar>
  }
</div>
